// Sync Action Types

export const REQUEST_INIT = "REQUEST_INIT";
export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
export const REQUEST_FAILURE = "REQUEST_FAILURE";

// Async action type

export const FETCH_USER_DATA = "FETCH_USER_DATA";
export const REMOVE_USER = "REMOVE_USER";
